/* eslint-disable no-use-before-define, no-restricted-globals, import/no-cycle */
// @ts-expect-error
import Dropdowns from 'a11y-dropdown-component';
import { VARIANT_SWITCH } from '../../events';
import addSelectDropdowns from '../dropdowns/select';
import addLazyLoad from '../lazyLoad/index';
import isMobileDisplay from '../mobile/check';
import addState from '../states/index';
import addTabs from '../tabs/index';
import zoom from '../zoom/index';
import { clearCtas, renderProductCta } from './cta/ProductCta';
import radioCheckbox from './radioCheckbox';
import addStickyProductBar from './sticky';
import { crossSellOtherSizes, otherVariantsProduct, otherVariantsProductLoop } from '../sliders/sliders';
import addCollapses from '../collapse';
import { setHTMLWithScripts } from '../../utils';
export function switchVariant(variantId, shouldUpdateSlider = true) {
    if (window.variants && window.variants[variantId] && document.body.dataset.variant !== variantId) {
        const variant = window.variants[variantId];
        const productSelector = 'article[data-component="product"]';
        const mainContent = document.querySelector(productSelector);
        document.body.dataset.variant = variantId;
        if (!mainContent) {
            return;
        }
        const isMobileDisplayVar = isMobileDisplay();
        const selectedInputSize = document.querySelector(`input[name="ean[${isMobileDisplayVar ? 'mobile' : 'desktop'}][]"][type=checkbox]:checked`);
        history.replaceState(history.state, null, variant.url + window.location.hash);
        // We need to clear mounted components before overriding the DOM to avoid zombies instances (preact doesn't know we are removing everything)
        clearCtas();
        // Update HTML and init all the things again
        setHTMLWithScripts(mainContent, variant.render, 'outer', productSelector);
        document.dispatchEvent(new CustomEvent(VARIANT_SWITCH, {
            detail: {
                variantId,
                shouldUpdateSlider,
            },
        }));
        renderProductCta();
        Dropdowns.init();
        addSelectDropdowns();
        addLazyLoad();
        addTabs();
        addState();
        radioCheckbox();
        zoom();
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        productSwitcher();
        addStickyProductBar();
        addCollapses();
        crossSellOtherSizes();
        if (selectedInputSize) {
            let selector = `input[name="ean[${isMobileDisplayVar ? 'mobile' : 'desktop'}][]"][type=checkbox][data-size="${selectedInputSize.dataset.size}"]`;
            if (isMobileDisplayVar) {
                selector = `${selector} + label`;
            }
            const newInputSize = document.querySelector(selector);
            if (newInputSize) {
                const event = new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    composed: true,
                    view: window,
                });
                newInputSize.dispatchEvent(event);
            }
        }
        // Cross sell variants
        if (window.variantsCrossSell && window.variantsCrossSell[variantId]) {
            const variants = window.variantsCrossSell[variantId];
            const variantsSection = document.querySelector('section[data-components="variants"]');
            if (variantsSection) {
                variantsSection.innerHTML = variants.render;
            }
            setTimeout(() => {
                otherVariantsProduct();
                otherVariantsProductLoop();
            }, 100);
        }
    }
}
const handleProductSwitch = (e) => {
    const variantId = e.target.dataset.variantReloadId;
    if (window.variants && window.variants[variantId]) {
        e.preventDefault();
        switchVariant(variantId);
    }
};
export default function productSwitcher() {
    const variantLinks = document.querySelectorAll('a[data-variant-reload-id]');
    variantLinks.forEach((link) => {
        link.addEventListener('click', handleProductSwitch);
    });
}
